module.exports = __webpack_public_path__ + "img/sf-footer-icon.a03f28a.webp";